import '@ant-design/v5-patch-for-react-19';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ConfigProvider, message } from 'antd';
import zhCN from 'antd/locale/zh_CN';
import './utils/dayjsApp';
import App from './App';
import './index.css';
import './i18n';
import { UserProvider } from './store/UserContext';
import { BrowserRouter } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { initPageRefreshHandler } from './utils/pageRefreshHandler';
import { fetchDeploymentContext } from './api/deployment.js';
import { APP_LOGO } from './config/brand';
import { ensureBMapGL } from './utils/loadBMapGL';

ensureBMapGL().catch((err) => {
  console.warn('[tianditu] 地图脚本未就绪', err?.message || err);
});

const faviconLink = document.querySelector('link[rel="icon"]');
if (faviconLink) {
  faviconLink.href = APP_LOGO;
}

// 全局悬浮提示：3 秒自动消失（替代页面内常驻 Alert 提醒）
message.config({
  duration: 3,
  maxCount: 3
});

// 初始化主题
const savedTheme = localStorage.getItem('theme') || 'light';
const root = document.documentElement;
root.classList.remove('light', 'dark');
root.classList.add(savedTheme);

// 初始化页面刷新处理器
initPageRefreshHandler();

// 预加载部署上下文（登录页品牌 / 驾驶舱默认农场）
fetchDeploymentContext().catch(() => {});

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ConfigProvider locale={zhCN}>
      <ErrorBoundary>
        <BrowserRouter>
          <UserProvider>
            <App />
          </UserProvider>
        </BrowserRouter>
      </ErrorBoundary>
    </ConfigProvider>
  </React.StrictMode>
);


